import React from 'react';
import ReactDOM from 'react-dom';
require('./FormItemImageDialog.css');
class FormItemImageDialog extends React.Component {
  constructor(props) {
    super(props);
    this.resourceURL = window.parent.window.userInfos.resourceURL;
    this.serviceURL = window.parent.window.userInfos.serviceURL;
    this.imgPath = props.imgPath;
    this.imgName = props.imgName;
    this.imgNum = props.imgNum;
    this.imgs = props.imgs;
  }
  render () {
    var imgList = this.getContent();
    return (<div className="modal " ref={node=>this.FormItemImage_DialogModel=node} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center'  }}>
    <div className=" ui-draggable" style={{ alignSelf: "center", display: 'flex', flexFlow: 'column', background: "#ffffff", background: '#FFFFFF', border: '1px solid #9B9B9B', boxShadow: '0 0 41px 5px rgba(0,0,0,0.25)', borderRadius: '2px', width: '540px', height: '399px' }}>
      <div className="modal-header" style={{ position: "relative" }}>
        <div className="modal-close" onClick={this.closeAttachmentHandler.bind(this)}></div>
        <h5 className="modal-title">图片</h5>
      </div>
      {/* <div style={{marginLeft:'35px',fontSize:'18px',verticalAlign:'middle',display:'flex',margiTtop: '2px'}}></div> */}
      <div style={{overflow:'auto'}}>
        <ul className="wrap-selectImg">
            {imgList}
        </ul>
      </div>
      <div className = "FormItemImage_DialogDelete">
      <span style={{fontSize:'18px',borderRight: '1px double',paddingRight: '6px',paddingLeft: '20px'}}>全选</span><input type="checkbox" id="FormItemImage_DialogDeleteQX" onClick={this.checkAllImages.bind(this)} /><button className = "FormItemImage_DialogDeleteBtn" onClick={this.deleteImgs.bind(this)}><i className="fa fa-trash-o" aria-hidden="true"></i>&nbsp;删除</button>
      </div>
    </div>
  </div>);
  }
  closeAttachmentHandler () {
    //关掉要卸载
    let $reactComponentContainer = $(this.FormItemImage_DialogModel);
    ReactDOM.unmountComponentAtNode($reactComponentContainer[0]);
    $reactComponentContainer.remove();
  }
  componentDidMount () {
    $(this.FormItemImage_DialogModel).children(':first').draggable({ cursor: "move", containment: "parent" });
    //this.doRefresh();
  }
  getContent(){
    var content = [];
    for (var i = 0; i < this.imgNum; i++) {
      var value = this.imgs[i];
      var path = this.imgPath+"/"+this.imgs[i];
      content.push(<li><input type="checkbox" name="imgs" id="" value={value} onClick={this.selectImage.bind(this)}  /><img src={path} alt="" style={{width: '140px',height: '120px'}} /><span><i></i></span><p>{value}</p></li>
      );
    }
    return content;
  }
  deleteImgs(){
    var obj = document.getElementsByName("imgs");
    var check_arr = [];
    for (var i = 0; i < obj.length; i++) {
        if (obj[i].checked)
            check_arr.push(obj[i].value);
    }
    this.props.deleteImgs(check_arr);

    let $reactComponentContainer = $(this.FormItemImage_DialogModel);
    ReactDOM.unmountComponentAtNode($reactComponentContainer[0]);
    $reactComponentContainer.remove();
  }
  checkAllImages(){
    var obj = document.getElementById('FormItemImage_DialogDeleteQX');
    var imgs =  document.getElementsByName("imgs");
    if(obj.checked){
      for (var i = 0; i < imgs.length; i++) {
        if (!imgs[i].checked)
        imgs[i].checked =  true;
      }
    }else{
      for (var i = 0; i < imgs.length; i++) {
        if (imgs[i].checked)
        imgs[i].checked =  false;
      }
    }
  }
  selectImage(){
    var imgs =  document.getElementsByName("imgs");
    var isAll = 1;
    for (var i = 0; i < imgs.length; i++) {
      if (!imgs[i].checked)
      isAll = 0
    }
    var obj = document.getElementById('FormItemImage_DialogDeleteQX');
    if(isAll == 0){
      obj.checked = false;
    }
    if(isAll == 1){
      obj.checked = true;
    }
  }
}

FormItemImageDialog.defaultProps = {
};
export default FormItemImageDialog;



// WEBPACK FOOTER //
// ./src/formItem/FormItemImageDialog.js